<template>
    <div>
        <AppHeader closeable="true" title="404 - Not found"></AppHeader>
        <section class="container container-lg">
            <figure class="figure mb--lg">
                <img src="/svg/404.svg">
            </figure>

            <h1 class="text--center mb--0">404 - Not found</h1>

            <router-link to="/" class="btn btn--block btn--primary mt--30 mb--lg">
                Go to Dashboard
            </router-link>
        </section>

        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from './partial/Navigation'
    import AppHeader from './partial/AppHeader'

    export default {
        name: "NotFound",
        components: {Navigation, AppHeader},
    }
</script>
